export default "__VITE_ASSET__BIkltCh___"